import React from 'react';

const EditFieldLabel = React.memo(function EditFieldLabel({ label, htmlFor, className = null }) {
    const classes = className != null ? className : "form-label sudHeader";
    return (
        <>
            <label htmlFor={htmlFor} className={classes}>{label}</label>
        </>
    );
});

export default EditFieldLabel;